import { NumericFormat } from 'react-number-format';

function getFormattedNumberStr(value: number, suffix = '') {
  return (
    <NumericFormat
      value={value}
      thousandSeparator=" "
      decimalSeparator=","
      decimalScale={2}
      displayType="text"
      suffix={suffix ? ` ${suffix}` : ''}
    />
  );
}

export { getFormattedNumberStr };
